export default "__VITE_ASSET__CovTt38H__"